<template>
  <div class="flex">
    <div>
      <a href="https://www.getbanyan.com/" target="_blank">
        <img class="cursor-pointer mx-auto xl:mt-8 mt-6 xl:mb-10 mb-6" :src="require('@/assets/images/black-logo.png')" width="220" height="40" />
      </a>
    </div>
    <div class="mr-3 flex items-center">
      <div class="sidebar">
        <div class="sidebar-backdrop" @click="closeSidebarPanel" v-if="isPanelOpen"></div>
        <transition name="slide">
          <div v-if="isPanelOpen" class="sidebar-panel bg-gradient relative">
            <LeftSidebar />
          </div>
        </transition>
      </div>
      <div
        id="burger"
        @click="toggle"
        class="rounded-full xl:h-12 xl:w-12 h-10 w-10 flex items-center justify-center bg-gradient text-white shadow-lg xl:hidden"
      >
        <slot>
          <button type="button" class="burger-button focus:outline-none" title="Menu">
            <span class="hidden">Toggle menu</span>
            <span class="burger-bar burger-bar--1"></span>
            <span class="burger-bar burger-bar--2"></span>
            <span class="burger-bar burger-bar--3"></span>
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import LeftSidebar from "@/components/common/LeftSidebar";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    LeftSidebar
  },
  computed: {
    ...mapGetters('common', ['isPanelOpen']),
  },
  methods: {
    ...mapMutations('common', ['setPanel', 'setBurger']),
    closeSidebarPanel() {
      this.setBurger(false);
      this.setPanel(false);
    },
    toggle() {
      this.setBurger(true);
      this.setPanel(true);
    },
  }
}
</script>

<style scoped>
/** sidebar **/

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.sidebar-backdrop {
  background-color: rgba(19, 15, 64, 0.2);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 999;
}

.sidebar-panel {
  overflow-y: auto;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 999;
  /*padding: 3rem 20px 2rem 20px;*/
  width: 300px;

}


.burger-button {
  position: relative;
  height: 30px;
  width: 32px;
  display: block;
  z-index: 999;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.burger-bar {
  background-color: white;
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  height: 2px;
  width: auto;
  margin-top: -1px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1), opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}

.burger-bar--2 {
  transform-origin: 100% 50%;
  transform: scaleX(0.8);
}

.burger-button:hover .burger-bar--2 {
  transform: scaleX(1);
}

.no-touchevents .burger-bar--2:hover {
  transform: scaleX(1);
}

.burger-bar--3 {
  transform: translateY(6px);
}

#burger.active .burger-button {
  transform: rotate(-180deg);
  z-index: 0;
}

#burger.active .burger-bar {
  background-color: #fff;
}

#burger.active .burger-bar--1 {
  transform: rotate(45deg);
}

#burger.active .burger-bar--2 {
  opacity: 0;
}

#burger.active .burger-bar--3 {
  transform: rotate(-45deg);
}
</style>